import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { PropsWithChildren } from 'react';
import { isDevelopment } from 'services/environment/Environment';

const client = new QueryClient();

export default function QueryProvider({ children }: PropsWithChildren<{}>) {
  return (
    <QueryClientProvider client={client}>
      {children} {isDevelopment && <ReactQueryDevtools buttonPosition="top-left" />}
    </QueryClientProvider>
  );
}
